import React, { PureComponent, createRef } from 'react'
import { connect } from 'react-redux'
import { Grid, Button } from '@material-ui/core'
import { getVehicles, searchVehicles } from '../../../actions/company'
import { complianceSync } from '../../../actions/compliance'
import SyncVehiclesModal from '../../../components/Modal/SyncVehiclesModal'

import { fetchEmployees } from '../../../actions/employee'
import { sortArrayByName } from '../../../utils/array'
import ContainerWithTitle from '../../../containers/HOC/ContainerWithTitle'
import { Appcues } from '../../../utils/constants'
import { hasAccess } from '../../../utils/api'
import { getShopList } from '../../../actions/shop'
import ListContainer from '../../../components/common/ListContainer'
import { isVehicleCompliance } from '../../../utils/common'

class CompanyVehicles extends PureComponent {
  addVehicleModal = createRef()
  syncVehiclesModal = createRef()

  componentDidMount() {
    this.props.dispatch(getVehicles())
    this.props.dispatch(fetchEmployees())
    this.props.dispatch(getShopList())
  }

  addVehicle = () => {
    Appcues.track('Adding Vehicle')
    this.props.history.push('/settings/company/vehicles/add')
  }

  openSyncVehiclesModal = () => {
    Appcues.track('Sync Vehicles')
    this.syncVehiclesModal.current.handleClickOpen()
  }

  syncVehicles = () => {
    const { session = {} } = this.props.authReducer
    const isNmCcdCompliance =
      session && session.assignedShop && session.assignedShop.complianceType === 'NM_CCD'

    if (isNmCcdCompliance) {
      this.sync()
      return
    }

    this.openSyncVehiclesModal()
  }

  state = {
    showEmptyVehicle: false,
    selectedToDeleteVehicle: {},
    newVehicle: {},
    term: '',
  }

  constructor(props) {
    super(props)
  }

  onChangeTerm = (e) => {
    this.setState({ term: e.target.value })
  }

  viewVehicle = (id) => {
    this.props.history.push(`/settings/company/vehicles/${id}/edit`)
  }

  onSearch = (value) => {
    this.props.dispatch(searchVehicles(value))
  }

  sync = async () => {
    Appcues.track('Syncing Compliance Vehicles')
    const syncType = ['SYNC_VEHICLES']
    this.props
      .dispatch(complianceSync(syncType))
      .then((response) => {
        Appcues.track('sync succesful')
        this.syncVehiclesModal.current.handleClose()
      })
      .catch(() => {
        Appcues.track('sync failed')
      })
  }

  render() {
    const { shopsList = {} } = this.props.shopReducer || {}

    const { vehicles = {} } = this.props.companyReducer

    const { session = {} } = this.props.authReducer
    const isBioTrackCompliance =
      session && session.assignedShop && isVehicleCompliance(session.assignedShop.complianceType)
    const isNmCcdCompliance =
      session && session.assignedShop && session.assignedShop.complianceType === 'NM_CCD'

    const vehiclesValues = sortArrayByName(vehicles.values)
    const activeShops =
      shopsList && shopsList.values
        ? sortArrayByName(shopsList.values.filter((shop) => shop.active))
        : []

    let vehiclesColumns = ['Name', 'Year', 'Make', 'Model', 'Plate', 'Location']
    let vehicleFields = [
      'name',
      'year',
      'vehicleMake',
      'vehicleModel',
      'vehicleLicensePlate',
      'locationName',
    ]
    if (isBioTrackCompliance) {
      vehiclesColumns.push('BioTrack TransID')
      vehicleFields.push('biotrackTransId')
    }
    if (isNmCcdCompliance) {
      vehiclesColumns.push('NM CCD ID')
      vehicleFields.push('complianceId')
    }
    vehiclesColumns.push('')
    vehicleFields.push('action')
    let vehicleInfo =
      vehiclesValues &&
      vehiclesValues.length > 0 &&
      vehiclesValues.map((veh) => {
        const selectedShop = activeShops.find((shop) => shop.id === veh.associatedShopId)
        return {
          ...veh,
          locationName: selectedShop && selectedShop.name,
        }
      })

    return (
      <div>
        <Grid container>
          <Grid spacing={2} className="addButton" item xs={12} sm={12} md={12} lg={12}>
            {hasAccess() ? (
              <Grid item xs={12} sm={12} md={12} lg={12}>
                <Button
                  variant="raised"
                  className="primary-button pull-right margin"
                  onClick={this.addVehicle}
                >
                  NEW VEHICLE
                </Button>
                {(isBioTrackCompliance || isNmCcdCompliance) && (
                  <Button
                    variant="raised"
                    className="primary-button pull-right margin"
                    onClick={this.syncVehicles}
                  >
                    SYNC
                  </Button>
                )}
              </Grid>
            ) : (
              <Grid item xs={12} sm={12} md={12} lg={12} />
            )}
          </Grid>
        </Grid>
        <Grid container>
          <SyncVehiclesModal ref={this.syncVehiclesModal} onConfirm={this.sync} />
        </Grid>
        <ListContainer
          columns={vehiclesColumns}
          list={vehicleInfo}
          fields={vehicleFields}
          onChangeTerm={this.onChangeTerm}
          actionText={'View'}
          onClick={this.viewVehicle}
          onSearch={this.onSearch}
          term={this.state.term}
          onClickRow={this.viewVehicle}
        />
      </div>
    )
  }
}

export default connect((state) => ({
  dispatch: state.dispatch,
  companyReducer: state.companyReducer,
  shopReducer: state.shopReducer,
  authReducer: state.authReducer,
}))(ContainerWithTitle(CompanyVehicles, 'Vehicles'))



// WEBPACK FOOTER //
// ./src/containers/Settings/Company/CompanyVehicles.js